module.exports = __webpack_public_path__ + "static/media/2DGACM11.2b1cd453.jpg";